export const INVESTOR_SESSION_KEY = 'vexu.investorAccess'

/**
 * Front-end gate for the investor deck. Replace with a real auth service
 * before wider distribution — this only keeps the deck out of casual view.
 */
/** Investors see the full deck; marketing sees it without the investment ask. */
export type DeckAudience = 'investor' | 'marketing'

const CREDENTIALS: { email: string; password: string; audience: DeckAudience }[] = [
  { email: 'investor@vexu.ai', password: 'Vexu2026', audience: 'investor' },
  { email: 'accounts@vexu.ai', password: 'Accounts@0123', audience: 'investor' },
  { email: 'accounting@vexu.ai', password: 'Alaa@0123', audience: 'investor' },
  { email: 'invest@vexu.ai', password: 'Invest@91230', audience: 'investor' },
  { email: 'marketing@vexu.ai', password: 'Marketing@0123', audience: 'marketing' },
]

/** Returns the audience for valid credentials, or null. */
export function verifyInvestorCredentials(
  email: string,
  password: string,
): DeckAudience | null {
  const normalized = email.trim().toLowerCase()
  const match = CREDENTIALS.find(
    (entry) => entry.email === normalized && entry.password === password,
  )
  return match ? match.audience : null
}

function readStoredValue(): string | null {
  if (typeof window === 'undefined') return null
  try {
    return (
      window.localStorage.getItem(INVESTOR_SESSION_KEY) ??
      window.sessionStorage.getItem(INVESTOR_SESSION_KEY)
    )
  } catch {
    return null
  }
}

export function readInvestorSession(): boolean {
  const value = readStoredValue()
  return value === 'granted' || value === 'marketing'
}

export function readDeckAudience(): DeckAudience {
  return readStoredValue() === 'marketing' ? 'marketing' : 'investor'
}

export function writeInvestorSession(remember: boolean, audience: DeckAudience) {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(INVESTOR_SESSION_KEY)
    window.sessionStorage.removeItem(INVESTOR_SESSION_KEY)
    const store = remember ? window.localStorage : window.sessionStorage
    store.setItem(
      INVESTOR_SESSION_KEY,
      audience === 'marketing' ? 'marketing' : 'granted',
    )
  } catch {
    /* storage unavailable — session stays in memory only */
  }
}
